import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, Linkedin } from "lucide-react";
import { PROFILE } from "../../../lib/data";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const buildLinkedInShareHref = (slug) => {
  const shareUrl = `${BACKEND_URL}/api/share/case/${slug}`;
  return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
    shareUrl
  )}`;
};

export const CaseTalkCTA = ({ campaign: c }) => (
  <div className="col-span-12 md:col-span-5">
    <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-2">
      Want the full conversation?
    </div>
    <h3 className="text-3xl md:text-5xl font-bold tracking-tight leading-[0.95] mb-6">
      Let&apos;s talk about<br />this work.
    </h3>
    <div className="flex flex-wrap gap-3">
      <a
        href={`mailto:${PROFILE.email}?subject=About ${encodeURIComponent(c.title)}`}
        data-testid="case-cta-email"
        className="inline-flex items-center gap-2 bg-[var(--ink)] text-[var(--paper)] px-5 py-3 text-[11px] tracking-[0.2em] uppercase font-medium hover:bg-[var(--paper)] hover:text-[var(--ink)] border border-[var(--ink)] transition-colors"
      >
        Email Yash
        <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.75} />
      </a>
      <a
        href={buildLinkedInShareHref(c.slug)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="case-cta-share"
        className="inline-flex items-center gap-2 border border-[var(--ink)] px-5 py-3 text-[11px] tracking-[0.2em] uppercase font-medium hover:bg-[var(--ink)] hover:text-[var(--paper)] transition-colors"
      >
        <Linkedin className="w-3.5 h-3.5" strokeWidth={1.75} />
        Share on LinkedIn
      </a>
      <Link
        to="/#campaigns"
        data-testid="case-cta-all-work"
        className="inline-flex items-center gap-2 border border-[var(--ink)] px-5 py-3 text-[11px] tracking-[0.2em] uppercase font-medium hover:bg-[var(--ink)] hover:text-[var(--paper)] transition-colors"
      >
        <ArrowLeft className="w-3.5 h-3.5" strokeWidth={1.75} />
        All work
      </Link>
    </div>
  </div>
);
